const compareCaseInsensitive = (a, b, sortDirection = 'asc') => {
    if (a && b) {
        const stringA = String(a);
        const stringB = String(b);
        return sortDirection === 'asc'
            ? (stringA.trim().toLowerCase().localeCompare(stringB.trim().toLowerCase()))
            : (stringB.trim().toLowerCase().localeCompare(stringA.trim().toLowerCase()));
    } else if (!a) {
        if (sortDirection === 'desc') {
            return -1;
        } else if (sortDirection === 'asc') {
            return 1;
        }
    } else if (!b) {
        if (sortDirection === 'asc') {
            return -1;
        } else if (sortDirection === 'desc') {
            return 1;
        }
    } else {
        return 0;
    }
};

export default compareCaseInsensitive;


// WEBPACK FOOTER //
// ./src/helpers/CompareCaseInsensitive.js